<template>
    <div>
        <b-card header-tag="header" class="m-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
                    Legislações
                    <b-button size="sm" class="float-right m-1" to="/entrega/enviar-legislacao">
                        <font-awesome-icon icon="plus" class="mr-3" />
                        Nova Entrega
                    </b-button>
                </h6>
            </template>
            <b-card-body>
                <card-filtros-busca>
                    <b-form @submit.prevent="buscarLegislacoes" @reset.prevent="limparFiltros" v-if="showFilters">
  <b-row>
    <b-col cols="12" md="2">
      <b-form-group id="input-group-exercicio" label-size="md" label="Exercício">
        <b-form-input type="number" v-model="filtros.exercicio"></b-form-input>
      </b-form-group>
    </b-col>
    <b-col cols="12" md="4">
      <b-form-group id="input-group-tipo-de-entrega" label-size="md" label="Tipo de Entrega">
        <b-form-select id="select-filtros-tipoDeEntrega" v-model="filtros.tipoDeEntrega"
          :options="comboTiposDeEntrega">
        </b-form-select>
      </b-form-group>
    </b-col>
    <b-col cols="12" md="3" class="pt-4 d-flex justify-content-center justify-content-md-start">
      <b-button type="reset" variant="outline-secondary" class="mr-2">
        <font-awesome-icon icon="redo" class="mr-2" />Limpar
      </b-button>
      <b-button type="submit">
        <font-awesome-icon icon="search" class="mr-2" />Filtrar
      </b-button>
    </b-col>
  </b-row>
</b-form>
                </card-filtros-busca>

                <b-table :busy="tableBusy" :fields="fields" hover no-border-collapse :items="items" sort-by=""
                    :sort-desc="true" striped stacked="lg" responsive per-page="0" :current-page="currentPage" show-empty>
                    <template #empty>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #emptyfiltered>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-dark">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong class="loading-text">Carregando...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <div class="actions-icons">
                            <b-link class="text-dark" @click="verDetalhes(row.item)">
                                <font-awesome-icon icon="eye" />
                                <div style="font-size: 12px">Ver detalhes</div>
                            </b-link>
                        </div>
                    </template>
                </b-table>
                <table-pagination v-if="totalRows" :total-rows="totalRows" :per-page="pageSize"
                    @pageChange="novaPaginaLegislacoes">
                </table-pagination>
            </b-card-body>
        </b-card>
    </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import legislacaoService from "@/services/entregas/legislacaoService"
import { store } from "@/store";
import { SelectValue } from '@/types/select-value'
import { FiltrosLegislacao } from '@/types/entregas/legislacao/filtros-legislacao'
import { Legislacao } from '@/types/entregas/legislacao/legislacao'
import { TableField } from '@/types/table-field'
import { fieldsLegislacao } from '@/types/entregas/legislacao/fields-legislacao'
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue'
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';


const CompProps = Vue.extend({
    name: 'ConsultaLegislacao',
    components: { CardFiltrosBusca, TablePagination },
})

@Component
export default class ConsultaLegislacao extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = fieldsLegislacao
    filtros: FiltrosLegislacao = new FiltrosLegislacao()
    items: Legislacao[] = []
    comboTiposDeEntrega: SelectValue[] = []
    showFilters = true
    tableBusy = false
    loadingPeriodos = false

    //paginação
    currentPage = 1
    pageSize = 10
    totalRows = 0

    novaPaginaLegislacoes(page): void {
        this.currentPage = page
        this.buscarLegislacoes()
    }
    async buscarLegislacoes(): Promise<void> {
        this.tableBusy = true
        try {
            const leg = await legislacaoService.consultarLegislacoes(this.filtros, this.currentPage);
            this.totalRows = leg.totalRows
            this.items = leg.legislacoes.map((legislacao: any) => {
                const retorno = Object.assign(new Legislacao(), legislacao)
                retorno.tratarDadosDaAPI()
                return retorno
            })
        } catch (e: any) {
            this.items = []
            this.tratarError(e)
        } finally {
            this.tableBusy = false
        }
    }

    limparFiltros(): void {
        this.filtros.limpar()
        // Trick to reset/clear native browser form validation state
        this.showFilters = false
        this.$nextTick(() => {
            this.showFilters = true
        })
    }

    async mounted() {
        try {
            store.blockScreen = true
            this.filtros.limpar()
            await this.getComboTiposEntrega()
            await this.buscarLegislacoes()
        } finally {
            store.blockScreen = false
        }
    }

    async getComboTiposEntrega() {
        const combos = await legislacaoService.getTiposEntrega()
        this.comboTiposDeEntrega = [
            { text: 'SELECIONE', value: '', disabled: true },
            ...combos.map(tipoEntrega => { return { text: String(tipoEntrega.Descricao), value: tipoEntrega.IdTipoEntrega } })
        ]
    }

    verDetalhes(legislacaoSelecionada: Legislacao) {
        this.$router.push(`/entrega/detalhes-legislacao/${legislacaoSelecionada.IdEntrega}`);
    }

} 
</script>

